import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { ApiClientError } from '@/lib/api-client';

import {
  confirmGetitPurchasePrice,
  fetchGetitPurchasePrice,
  lockGetitPurchasePrice,
  recomputeGetitPurchasePrice,
} from './api';
import type { GetitPurchasePriceDto } from './types';

const KEY = 'getit-purchase-price' as const;

export const useGetitPurchasePrice = (batchId: string | undefined) => {
  return useQuery<GetitPurchasePriceDto | null, ApiClientError>({
    queryKey: [KEY, batchId],
    queryFn: () => fetchGetitPurchasePrice(batchId!),
    enabled: !!batchId,
    placeholderData: (prev) => prev,
  });
};

export const useRecomputeGetitPurchasePrice = (batchId: string | undefined) => {
  const qc = useQueryClient();
  return useMutation<GetitPurchasePriceDto, ApiClientError, void>({
    mutationFn: () => recomputeGetitPurchasePrice(batchId!),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY, batchId] }),
  });
};

export const useConfirmGetitPurchasePrice = (batchId: string | undefined) => {
  const qc = useQueryClient();
  return useMutation<GetitPurchasePriceDto, ApiClientError, string>({
    mutationFn: (id) => confirmGetitPurchasePrice(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY, batchId] }),
  });
};

export const useLockGetitPurchasePrice = (batchId: string | undefined) => {
  const qc = useQueryClient();
  return useMutation<GetitPurchasePriceDto, ApiClientError, string>({
    mutationFn: (id) => lockGetitPurchasePrice(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY, batchId] }),
  });
};
